'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var signup = require('@gig/magic-sdk/dist/adapter/users/signup');
var config = require('../../config/config.js');
var getAmlStatus = require('@gig/magic-sdk/dist/adapter/users/getAmlStatus');
var trackingV2_interface = require('./tracking-v2.interface.js');
var events = require('@gig/magic-sdk/dist/events');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class TrackingServiceV2 {
  constructor() {
    this.user = null;
    this.balance = null;
    this.page = null;
    this.userAccounts = null;
    this.jurisdiction = "MGA";
    this.previousPage = null;
    this.handlers = [];
  }
  onTrack(handler) {
    this.handlers.push(handler);
    return () => {
      this.handlers.splice(this.handlers.indexOf(handler), 1);
    };
  }
  track(event) {
    if (!event.hasOwnProperty("exp")) {
      const isPWA = window.navigator.standalone || false;
      event = __spreadProps(__spreadValues({}, event), {
        isPWA
      });
    }
    this.handlers.forEach((handler) => {
      try {
        handler(event);
      } catch (e) {
        console.error(e);
      }
    });
  }
  setPage(page) {
    if (page === null) {
      this.page = null;
      this.previousPage = null;
      return;
    }
    this.previousPage = this.page;
    this.page = page;
    this.updateUserDetails();
  }
  setUser(user) {
    this.user = user;
    this.updateUserDetails();
  }
  setBalance(balance) {
    this.balance = balance;
    this.updateUserDetails();
  }
  setUserAccounts(userAccounts) {
    this.userAccounts = userAccounts;
    this.updateUserDetails();
  }
  setJurisdiction(jurisdiction) {
    this.jurisdiction = jurisdiction;
    this.updateUserDetails();
  }
  setExperiments(identifiers) {
    this.track({ exp: identifiers });
  }
  trackPageView(page) {
    if (page) {
      this.setPage(page);
    }
    const pageInfo = this.getPageInfo();
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.PAGE_VIEW,
      eventAction: pageInfo.currentPage,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackLogin() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.LOGIN,
      eventAction: trackingV2_interface.UserActivityAction.LOGGED_IN,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackFirstLogin() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.LOGIN,
      eventAction: trackingV2_interface.UserActivityAction.FIRST_LOGIN,
      value: null,
      eventLabel: null
    };
    this.track(event);
  }
  trackFailedLogin(_, error) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.LOGIN,
      eventAction: trackingV2_interface.UserActivityAction.LOGIN_FAILED,
      eventLabel: error,
      value: null
    };
    this.track(event);
  }
  trackLogout(statusCode) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.LOGIN,
      eventAction: trackingV2_interface.UserActivityAction.LOGGED_OUT,
      eventLabel: this.convertSessionStatus(statusCode),
      value: null
    };
    this.track(event);
  }
  trackSelfExclusion(period) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.SELF_EXCLUSION,
      eventAction: period,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackCookieAcceptance() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.USER_ACTIVITY,
      eventCategory: trackingV2_interface.TrackEventCategory.COOKIE_CONSENT,
      eventAction: trackingV2_interface.UserActivityAction.COOKIES_ACCEPTED,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackBalanceZero() {
    this.trackBalance(trackingV2_interface.UserBalanceEventAction.ZERO);
  }
  trackBalanceNearZero() {
    this.trackBalance(trackingV2_interface.UserBalanceEventAction.NEAR_ZERO);
  }
  trackEnterGame(gameInfo) {
    if (!this.user) {
      this.trackGame(gameInfo, trackingV2_interface.GameEventAction.FREE_PLAY);
      return;
    }
    this.trackGame(gameInfo, trackingV2_interface.GameEventAction.REAL_PLAY);
  }
  trackLeaveGame(gameInfo) {
    this.trackGame(gameInfo, trackingV2_interface.GameEventAction.END_PLAY);
  }
  trackGameCategorySelect(categorySlug, categoryName) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.GAME_CATEGORY,
      eventCategory: trackingV2_interface.TrackEventCategory.LOBBY,
      eventAction: "Select category",
      eventLabel: categorySlug,
      value: categoryName
    };
    this.track(event);
  }
  trackRegistrationStep(step, btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.REGISTRATION,
      eventAction: step,
      eventLabel: null,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackRegisterClosed(step, btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.REGISTRATION,
      eventAction: trackingV2_interface.RegisterEventAction.CLOSE,
      eventLabel: step,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackChangeRegistrationPhoneNumber(btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.EDIT_PHONE, btag);
  }
  trackResendActivationCode(btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.RESEND_CODE, btag);
  }
  trackResendEmail(btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.RESEND_EMAIL, btag);
  }
  trackRegistrationAttempt(_, btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.ATTEMPT, btag);
  }
  trackRegistrationComplete(email, btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.ACCEPTED, btag);
  }
  trackRegistrationConfirmed(btag) {
    this.trackRegistrationAction(trackingV2_interface.RegisterEventAction.CONFIRMED, btag);
  }
  trackDepositIntent() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.DEPOSIT,
      eventAction: trackingV2_interface.DepositEventAction.OPEN,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackDepositStarted(method) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.DEPOSIT,
      eventAction: trackingV2_interface.DepositEventAction.STARTED,
      eventLabel: null,
      value: method
    };
    this.track(event);
  }
  trackDepositAttempt(depositInfo) {
    this.trackDepositAction(trackingV2_interface.DepositEventAction.ATTEMPT, depositInfo);
  }
  trackDeposit(depositInfo) {
    this.trackDepositAction(trackingV2_interface.DepositEventAction.DEPOSIT, depositInfo);
  }
  trackDepositError(depositInfo) {
    this.trackDepositAction(trackingV2_interface.DepositEventAction.ERROR, depositInfo);
  }
  trackFirstTimeDeposit(depositInfo) {
    this.trackDepositAction(trackingV2_interface.DepositEventAction.FTD, depositInfo);
  }
  trackNewDepositingCustomer(depositInfo) {
    this.trackDepositAction(trackingV2_interface.DepositEventAction.NDC, depositInfo);
  }
  trackWithdrawalIntent() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.WITHDRAWAL,
      eventCategory: trackingV2_interface.TrackEventCategory.WITHDRAWAL,
      eventAction: trackingV2_interface.WithdrawalEventAction.OPEN,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackWithdrawalStarted(method) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.WITHDRAWAL,
      eventCategory: trackingV2_interface.TrackEventCategory.WITHDRAWAL,
      eventAction: trackingV2_interface.WithdrawalEventAction.STARTED,
      eventLabel: null,
      value: method
    };
    this.track(event);
  }
  trackWithdrawalAttempt(withdrawalInfo) {
    this.trackWithdrawal(trackingV2_interface.WithdrawalEventAction.ATTEMPT, withdrawalInfo);
  }
  trackWithdrawalSuccess(withdrawalInfo) {
    this.trackWithdrawal(trackingV2_interface.WithdrawalEventAction.WITHDRAW, withdrawalInfo);
  }
  trackWithdrawalError(withdrawalInfo) {
    this.trackWithdrawal(trackingV2_interface.WithdrawalEventAction.ERROR, withdrawalInfo);
  }
  trackQDIntent() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.QUICK_DEPOSIT,
      eventAction: trackingV2_interface.QuickDepositEventAction.INTENT,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackQDAttempt(value) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.QUICK_DEPOSIT,
      eventAction: trackingV2_interface.QuickDepositEventAction.ATTEMPT,
      eventLabel: null,
      value
    };
    this.track(event);
  }
  trackQDSuccess(value) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.QUICK_DEPOSIT,
      eventAction: trackingV2_interface.QuickDepositEventAction.SUCCESS,
      eventLabel: null,
      value
    };
    this.track(event);
  }
  trackQDError(value, eventLabel = null) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.QUICK_DEPOSIT,
      eventAction: trackingV2_interface.QuickDepositEventAction.ERROR,
      eventLabel,
      value
    };
    this.track(event);
  }
  trackSearch(searchQuery) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.SEARCH,
      eventCategory: trackingV2_interface.TrackEventCategory.SEARCH,
      eventAction: null,
      eventLabel: null,
      value: searchQuery
    };
    this.track(event);
  }
  trackIdDocumentUploaded(idDocType) {
    this.trackDocumentUploaded(getAmlStatus.DocumentType.PHOTO_ID, idDocType);
  }
  trackAddressDocumentUploaded() {
    this.trackDocumentUploaded(getAmlStatus.DocumentType.ADDRESS);
  }
  trackPaymentDocumentUploaded() {
    this.trackDocumentUploaded(getAmlStatus.DocumentType.PAYMENT);
  }
  trackRgQuestionnaireSubmit(score, maxScore) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.RG_QUESTIONNAIRE,
      eventCategory: trackingV2_interface.TrackEventCategory.RG_QUESTIONNAIRE,
      eventAction: "Submit",
      eventLabel: null,
      value: score,
      maxScore
    };
    this.track(event);
  }
  trackSeasonalGiftSelection(giftIndex) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.SEASONAL_EVENT,
      eventCategory: trackingV2_interface.TrackEventCategory.SEASONAL_EVENT,
      eventAction: trackingV2_interface.SeasonalEventAction.GIFT_SELECTED,
      eventLabel: null,
      value: giftIndex + 1
    };
    this.track(event);
  }
  trackSeasonalEventClosed(stage) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.SEASONAL_EVENT,
      eventCategory: trackingV2_interface.TrackEventCategory.SEASONAL_EVENT,
      eventAction: trackingV2_interface.SeasonalEventAction.CLOSE,
      eventLabel: null,
      value: stage + 1
    };
    this.track(event);
  }
  trackSeasonalEventCompleted() {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.SEASONAL_EVENT,
      eventCategory: trackingV2_interface.TrackEventCategory.SEASONAL_EVENT,
      eventAction: trackingV2_interface.SeasonalEventAction.CTA,
      eventLabel: null,
      value: null
    };
    this.track(event);
  }
  trackMembershipRegisterAttempt(btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.MEMBERSHIP_REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.MEMBERSHIP_REGISTRATION,
      eventAction: trackingV2_interface.MembershipRegistrationEventAction.ATTEMPT,
      eventLabel: null,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackMembershipRegisterClosed(step, btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.MEMBERSHIP_REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.MEMBERSHIP_REGISTRATION,
      eventAction: trackingV2_interface.MembershipRegistrationEventAction.CLOSE,
      eventLabel: step,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackMembershipRegisterFlow(step, btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.MEMBERSHIP_REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.MEMBERSHIP_REGISTRATION,
      eventAction: step,
      eventLabel: null,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackMembershipRegisterSubmittedAndAccepted(btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.MEMBERSHIP_REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.MEMBERSHIP_REGISTRATION,
      eventAction: trackingV2_interface.MembershipRegistrationEventAction.ACCEPTED,
      eventLabel: null,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackDocumentUploaded(docType, idDocType) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.KYC,
      eventCategory: trackingV2_interface.TrackEventCategory.UPLOAD_DOCUMENT,
      eventAction: docType,
      eventLabel: idDocType || null,
      value: null
    };
    this.track(event);
  }
  trackWithdrawal(action, withdrawalInfo) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.WITHDRAWAL,
      eventCategory: trackingV2_interface.TrackEventCategory.WITHDRAWAL,
      eventAction: action,
      eventLabel: null,
      value: withdrawalInfo.amount,
      valueEUR: this.convertBalance(withdrawalInfo.amount),
      currency: withdrawalInfo.currency,
      withdrawalProvider: withdrawalInfo.method
    };
    this.track(event);
  }
  trackDepositAction(action, depositInfo) {
    var _a;
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.DEPOSIT,
      eventCategory: trackingV2_interface.TrackEventCategory.DEPOSIT,
      eventAction: action,
      eventLabel: null,
      value: depositInfo.amount,
      valueEUR: this.convertBalance(depositInfo.amount),
      currency: depositInfo.currency,
      depositCount: ((_a = this.user) == null ? void 0 : _a.depositCount) || 0,
      paymentProvider: depositInfo.method
    };
    this.track(event);
  }
  trackRegistrationAction(action, btag) {
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.REGISTRATION,
      eventCategory: trackingV2_interface.TrackEventCategory.REGISTRATION,
      eventAction: action,
      eventLabel: null,
      value: null,
      affiliateId: btag || ""
    };
    this.track(event);
  }
  trackGame(gameInfo, action) {
    var _a, _b;
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.GAME,
      eventCategory: gameInfo.isLive ? trackingV2_interface.TrackEventCategory.LIVE_CASINO : trackingV2_interface.TrackEventCategory.CASINO,
      eventAction: action,
      eventLabel: gameInfo.slug,
      value: ((_a = this.balance) == null ? void 0 : _a.balance) || 0,
      valueEUR: this.convertBalance(((_b = this.balance) == null ? void 0 : _b.balance) || 0),
      gameId: gameInfo.gameId
    };
    this.track(event);
  }
  trackBalance(type) {
    var _a, _b;
    const balance = ((_a = this.balance) == null ? void 0 : _a.balance) || 0;
    const event = {
      userId: this.getUserId(),
      event: trackingV2_interface.TrackEvent.BALANCE,
      eventCategory: trackingV2_interface.TrackEventCategory.BALANCE,
      eventAction: type,
      eventLabel: null,
      value: balance,
      valueEUR: this.convertBalance(balance),
      currency: (_b = this.user) == null ? void 0 : _b.currency
    };
    this.track(event);
  }
  updateUserDetails() {
    window.userDetails = __spreadValues(__spreadValues({}, this.getUserInfo()), this.getPageInfo());
  }
  getUserId() {
    return this.user && this.user.id ? this.user.id : "";
  }
  getUserInfo() {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
      userId: ((_a = this.user) == null ? void 0 : _a.userId) || "",
      username: ((_b = this.user) == null ? void 0 : _b.userName) || "",
      currency: ((_c = this.user) == null ? void 0 : _c.currency) || "",
      balance: ((_d = this.balance) == null ? void 0 : _d.balance) || 0,
      balanceEur: this.convertBalance(((_e = this.balance) == null ? void 0 : _e.balance) || 0),
      bonus: (_f = this.balance) == null ? void 0 : _f.bonusBalance,
      affiliateId: ((_g = this.user) == null ? void 0 : _g.affiliate) || null
    };
  }
  getPageInfo() {
    return {
      currentPage: this.page || window.location.href.replace(window.location.origin, ""),
      licence: this.jurisdiction,
      language: config.magicConfig.language
    };
  }
  convertSessionStatus(code) {
    switch (code) {
      case events.SessionCode.EXPIRED:
        return "expired";
      case events.SessionCode.LOGGED_IN:
        return "logged-in";
      case events.SessionCode.LOGGED_OFF:
        return "logged-out";
      case events.SessionCode.TERMINATED_BY_ANOTHER_LOGIN:
        return "terminated-by-another-login";
      case events.SessionCode.TERMINATED_BY_PRESET_TIME:
        return "terminated-by-preset-time";
      case events.SessionCode.TERMINATED_BY_SELF_EXCLUSION:
        return "terminated-by-self-exclusion";
      case events.SessionCode.TERMINATED_BY_GEO_LOCATION:
        return "terminated-by-geo-location";
      default:
        return "unknown";
    }
  }
  convertBalance(value) {
    var _a;
    const currency = (_a = this.user) == null ? void 0 : _a.currency;
    if (!currency) {
      return value;
    }
    const mappings = {
      [signup.Currency.DKK]: 10,
      [signup.Currency.SEK]: 10,
      [signup.Currency.NOK]: 10
    };
    const divider = mappings[currency] || 1;
    return value / divider;
  }
}

exports.TrackingServiceV2 = TrackingServiceV2;
